import { render } from "./orchestra-item.vue?vue&type=template&id=7f37b2a4"
import script from "./orchestra-item.vue?vue&type=script&lang=js"
export * from "./orchestra-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__